import { render, staticRenderFns } from "./AddLotinPo.vue?vue&type=template&id=6bbcdd2a&"
import script from "./AddLotinPo.vue?vue&type=script&lang=js&"
export * from "./AddLotinPo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports